var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-box"},[_c('progress-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showProgressBar),expression:"showProgressBar"}],ref:"progressBar",staticClass:"upload-progress",attrs:{"val":_vm.progressVal,"text":_vm.progressText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }